// Puzzles for the Word Wheel, one file per language.
// Each puzzle was built from a spelling dictionary, so the game can check words instantly and for free.

import { WHEEL_EN } from './wordWheelEnglish';
import { WHEEL_IT } from './wordWheelItalian';
import { WHEEL_ES } from './wordWheelSpanish';
import { WHEEL_FR } from './wordWheelFrench';
import { WHEEL_PT } from './wordWheelPortuguese';

const PUZZLES = {
    english: WHEEL_EN,
    italian: WHEEL_IT,
    spanish: WHEEL_ES,
    french: WHEEL_FR,
    portuguese: WHEEL_PT,
};

const split = (text) => (text ? text.split(' ').filter(Boolean) : []);

// Returns [{ letters, words: [...], extra: [...] }] for the language being learned
export function getWheelPuzzles(targetLang) {
    const list = PUZZLES[String(targetLang || 'italian').toLowerCase()] || [];
    return list.map(p => ({ letters: p.letters, words: split(p.words), extra: split(p.extra) }));
}